module.exports = __webpack_public_path__ + "static/media/cisco.4ed8086a.png";